import React, { Component } from "react";
import AboutStartup_BannerTitle from "../layouts/about/carees/AboutStartup_BannerTitle";
import AboutStartup_SideBar from "../layouts/about/carees/AboutStartup_SideBar";
import AboutPrivacyPolicy_SiteContent from "../layouts/about/legal/AboutPrivacyPolicy_SiteContent";
import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";
class AboutPrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "About Us",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/about-us",
          titlelink: "About Us",
          border: "|",
          name: "Careers",
          heading: "Careers",
        },
      ],
    };
  }
  render() {
    return (
      <div className="header-fixed page sidebar-right header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <AboutStartup_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={60}
                  data-mobile={60}
                  data-smobile={60}
                />
                <AboutPrivacyPolicy_SiteContent />
                <AboutStartup_SideBar />
              </div>
            </div>
          </div>
          <Footer />
          {this.state.headers.map((data, idx) => (
            <BottomBar data={data} key={idx} />
          ))}
        </div>
      </div>
    );
  }
}

export default AboutPrivacyPolicy;
